import React from "react";

// Titre à deux tons — Design System PROGÈRE V3.
// Segments : firstPart (couleur firstColor) + secondPart (couleur secondColor).
const COLORS = {
  white: "text-white",
  gold: "text-[#F2BC2E]",
  red: "text-[#F10D19]",
};

const SIZES = {
  sm: "text-xl sm:text-2xl",
  md: "text-2xl sm:text-3xl",
  lg: "text-3xl sm:text-4xl",
  xl: "text-4xl sm:text-5xl",
};

export function ProgereTwoToneTitle({
  firstPart,
  secondPart,
  firstColor = "white",
  secondColor = "gold",
  size = "lg",
  align = "left",
  underline = false,
  className = "",
}) {
  return (
    <h1
      className={`font-display font-bold tracking-tight ${SIZES[size] || SIZES.lg} ${align === "center" ? "text-center" : ""} ${className}`}
      data-testid="two-tone-title"
    >
      <span className={COLORS[firstColor] || COLORS.white}>{firstPart}</span>
      {secondPart && <span className={COLORS[secondColor] || COLORS.gold}> {secondPart}</span>}
      {underline && <span className="block mt-2 h-[3px] w-14 rounded-full bg-gradient-to-r from-[#F2BC2E] to-transparent" />}
    </h1>
  );
}
